<template>
    <nav class="navigation" :class="{'open': open}">
        <div class="menu">
            <div class="menu-item" v-for="item in items" :class="{'hasChildren': item.children}" @click="closeNav">
                <router-link :to="item.link">{{ $t(item.name) }}<i class="icon-expand_more" v-if="item.children"/></router-link>
                <div v-if="item.children" class="submenu">
                    <div class="submenu-item" v-for="item in item.children" @click="closeNav">
                        <router-link :to="item.link">{{ $t(item.name) }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'Navigation',
        data() {
            return {
                items: [
                    { name: 'navigation.home', link: { name: 'home', hash: '#home' } },
                    { name: 'navigation.about', link: { name: 'home', hash: '#about' } },
                    {
                        name: 'navigation.games',
                        link: '#games',
                        children: [
                            { name: 'navigation.virtual_sports', link: { name: 'home', hash: '#virtual-sports' } },
                            { name: 'navigation.number_games', link: { name: 'home', hash: '#number-games' } },
                            { name: 'navigation.jackpots', link: { name: 'home', hash: '#jackpots' } },
                            { name: 'navigation.slots', link: { name: 'home', hash: '#slots' } },
                            { name: 'navigation.demo', link: { name: 'home', hash: '#demo' } }
                        ]
                    },
                    { name: 'navigation.news', link: { name: 'news' } },
                    {
                        name: 'navigation.solutions',
                        link: { name: 'home', hash: '#solutions' },
                        children: [
                            { name: 'navigation.retail', link: { name: 'home', hash: '#solutions_retail' } },
                            { name: 'navigation.tv_games', link: { name: 'home', hash: '#solutions_tvgames' } },
                            { name: 'navigation.bet_n_go', link: { name: 'home', hash: '#solutions_betngo' } }
                        ]
                    },
                    { name: 'navigation.contacts', link: { name: 'home', hash: '#contacts' } }
                ]
            }
        },
        props: { open: Boolean },
        methods: {
            closeNav() {
                this.$emit('closeNav');
            }
        }
    }
</script>

<style lang="scss">
</style>
